import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('TableHeadCell', [
  'sorted',
  'sortIconEnd',
  'sortIconStart',
  'endJustified',
  'iconWrapper',
]);

const getTableHeadCellCss = ({ width }: { width?: string }) => css`
  background: var(--cds-color-neutral-background-primary-weak);
  color: var(--cds-color-neutral-primary-weak);
  font-weight: bold;
  text-align: start;
  width: ${width ? width : `auto`};
  vertical-align: bottom;

  svg {
    display: none;
    margin: 0 auto;
    height: 100%;
  }

  & > * {
    box-sizing: border-box;
    width: ${width ? width : `100%`};
    min-width: 120px;
    padding: var(--cds-spacing-200) var(--cds-spacing-300);
  }

  & > button {
    align-items: flex-end;
    border: none;
    cursor: pointer;
    background: none;
    display: flex;
    justify-content: space-between;
    position: relative;
    text-align: start;
    z-index: 1;

    & .${classes.iconWrapper} {
      height: 24px;
      min-width: 24px;
      position: relative;
    }

    &:focus-visible {
      background: var(--cds-color-interactive-background-primary-hover-weak);
      outline: none;
      border-radius: var(--cds-border-radius-50);
      box-shadow: inset 0 0 0 1px
        var(--cds-color-interactive-stroke-primary-focus);

      svg {
        display: block;
      }

      & * {
        color: var(--cds-color-interactive-primary-hover);
      }

      path {
        fill: var(--cds-color-interactive-primary-hover);
      }
    }
  }

  &.${classes.sortIconEnd} {
    & > * {
      padding-right: var(--cds-spacing-200);
      flex-direction: row;

      & .${classes.iconWrapper} {
        margin-left: var(--cds-spacing-50);
      }
    }

    &:hover {
      svg {
        display: block;
      }
    }
  }

  &.${classes.sortIconStart} {
    & > * {
      padding-left: var(--cds-spacing-200);
      flex-direction: row-reverse;

      & .${classes.iconWrapper} {
        margin-right: var(--cds-spacing-50);
      }
    }

    &:hover {
      svg {
        display: block;
      }
    }
  }

  &.${classes.sorted} {
    border-bottom: 2px solid var(--cds-color-interactive-primary-hover);

    svg {
      display: block;
    }
  }

  &.${classes.sorted}, &.${classes.sortIconStart}, &.${classes.sortIconEnd} {
    &:hover {
      border-radius: var(--cds-border-radius-50) var(--cds-border-radius-50) 0 0;
      background: var(--cds-color-interactive-stroke-primary-focus-invert);
      border-bottom: 2px solid var(--cds-color-interactive-primary-hover);

      path {
        fill: var(--cds-color-interactive-primary-hover);
      }

      * {
        color: var(--cds-color-interactive-primary-hover);
      }
    }
  }

  &.${classes.endJustified} {
    text-align: end;
  }
`;

export default getTableHeadCellCss;
